import { getVarValue } from './Sparky'
import { getFrameworkVar } from '@sparky/framework'
import _ from 'lodash'

export const FF_USE_LOCAL_TENANCY_SERVICE = 'use_local_tenancy_service'
export const FF_USE_LOCAL_SUBSCRIPTION_SERVICE = 'use_local_subscription_service'
export const FF_USE_LOCAL_INSTANCE_SERVICE = 'use_local_instance_service'
export const FF_USE_LOCAL_IAM_SERVICE = 'use_local_iam_service'

export const FF_ALLOW_ROOT_CREATE = 'allow_root_create'
export const FF_ENABLE_SERVICE_ACCOUNT = 'enable_service_account'
export const FF_ROLES_ENABLED = 'roles_enabled'
export const FF_CUSTOM_ROLES_ENABLED = 'custom_roles_enabled'
export const FF_PROVIDERS_ENABLED = 'providers_enabled'
export const FF_DISABLED_PRODUCT_LINKS = 'disabled_product_links'
export const FF_SHOW_SUBSCRIPTIONS = 'show_subscriptions'
export const FF_SHOW_DESCRIPTION = 'show_description'
export const FF_SKIP_DOMAIN_VALIDATION = 'skip_domain_validation'
export const FF_SHOW_EDIT = 'show_edit'
export const FF_PING_ID_ENABLED = 'ping_id_enabled'
export const FF_SHOW_SPLASH_SCREEN = 'show_splash_screen'
export const FF_AUTH_SUPPORT_ACCOUNTS = 'auth_support_accounts'
export const FF_SHOW_ALLOCATION = 'show_allocation'
export const FF_API_GATEWAY = 'use_api_gateway'
export const FF_VISIBLE_TSG_ID = 'visible_tsg_id'
export const FF_DAS_ENABLED = 'das_enabled'
export const FF_SUPPORT_CONTACT_ENABLED = 'support_contact_enabled'
export const FF_AMEND_ENABLED = 'amend_enabled'
export const FF_ENABLE_OKYO = 'enable_okyo'
export const FF_MULTI_DLP = 'multi_dlp'
export const FF_SEND_XSIG = 'send_xsig'
export const FF_DAS_XSIG = 'das_xsig'
export const FF_ENABLE_IOT = 'enable_iot'
export const FF_ENABLE_SASS = 'enable_sass'
export const FF_MODIFY_SUBSCRIPTION = 'modify_subscription'
export const FF_SHOW_TENANCY = 'show_tenancy'
export const FF_SHOW_IAM = 'show_iam'
export const FF_INTERNAL_APP = 'is_internal_app'
export const FF_ALLOW_PA_ROLE = 'allow_pa_role'
export const FF_ALLOW_CDL_ROLE = 'allow_cdl_role'
export const FF_ALLOW_CIE_ROLE = 'allow_cie_role'
export const FF_ALLOW_SDWAN_ROLE = 'allow_sdwan_role'
export const FF_ALLOW_IOT_ROLE = 'allow_iot_role'
export const FF_ALLOW_DLP_ROLE = 'allow_dlp_role'
export const FF_ALLOW_NG_CASB_ROLE = 'allow_ng_casb_role'
export const FF_ALLOW_BROWSER_ROLE = 'allow_browser_role'
export const FF_ALLOW_STRATA_INSIGHTS_ROLE = 'allow_strata_insights_role'
export const FF_SHOW_PERMISSIONS = 'show_permissions'
export const FF_USE_APPLICABLE_ROLES = 'use_applicable_roles'
export const FF_ROLE_SELECT_APPS = 'role_select_apps'
export const FF_V2_ROLE_MODAL = 'v2_role_modal'
export const FF_ROLE_INFO_ENABLED = 'role_info_enabled'
export const FF_DISABLE_SHARED_LIC_ADEM = 'disable_shared_lic_adem'
export const FF_STANDALONE_CDL = 'standalone_cdl'
export const FF_REQUIRE_PAN_IDENTITY = 'require_pan_identity'
export const FF_SHOW_LICENSED_PRODUCTS = 'show_licensed_products'
export const FF_MULTITENANT_PORTAL_NAME = 'multitenant_portal_name'
export const FF_ALLOW_DISABLE_ADDON = 'allow_disable_addon'
export const FF_SHOW_SCREEN_TOGGLE = 'show_screen_toggle'
export const FF_ENABLE_NG_CASB = 'enable_ng_casb'
export const FF_ENABLE_APP_LEVEL_REGION = 'enable_app_level_region'
export const FF_FEDRAMP_HIGH = 'fedramp_high'
export const FF_FEDRAMP_MOD = 'fedramp_mod'
export const FF_COMMERCIAL = 'commercial'
export const FF_HIDE_MSP_ROLES = 'hide_msp_roles'
export const FF_CDL_TSG_MIGRATION = 'cdl_tsg_migration'
export const FF_IAM_FILTER_ROLES = 'iam_filter_roles'
export const FF_IAM_FILTER_INHERITED = 'iam_filter_inherited'
export const FF_UNIFIED_ACTIVATION = 'unified_activation'
export const FF_ALLOW_INSTANCE_RENAME = 'allow_instance_rename'
export const FF_DISPLAY_SCOPE_COLUMN = 'display_scope_column'
export const FF_ENABLE_BACKBONE = 'enable_backbone'
export const FF_CUSTOM_ROLES_API = 'custom_roles_api'
export const FF_ENABLE_NG_CASB_ONE_APP = 'enable_ng_casb_one_app'
export const FF_AIOPS_CDL_TSG_MIGRATION = 'aiops_cdl_tsg_migration'
export const FF_USE_NEW_LEFT_NAV = 'use_new_left_nav'
export const FF_ENABLE_FEDERATION_MAPPING = 'enable_federation_mapping'
export const FF_ENABLE_SP_CERT_DOWNLOAD = 'enable_sp_cert_download'
export const FF_ENABLE_LOGGING_SERVICE = 'enable_logging_service'
export const FF_IAM_USE_ONEAPP_NAME = 'iam_use_oneapp_name'
export const FF_ENABLE_VERIFIED_WARNING = 'enable_verified_warning'
export const FF_UNIFIED_LICENSE_TABLE = 'unified_license_table'
export const FF_HIDE_SASE_TABLE = 'hide_sase_table'
export const FF_DISABLE_LICENSE_TABLE_EDIT = 'disable_license_table_edit'
export const FF_ENABLE_INSTANCE_LICENSE_EDIT = 'enable_instance_license_edit'
export const FF_LICENSE_TABLE_LABEL = 'license_table_label'
export const FF_ENABLE_PROFILE_ACTIVATION = 'enable_profile_activation'
export const FF_ENABLE_CIE_SHARING = 'enable_cie_sharing'
export const FF_SDWAN_TID_REMOVE = 'sdwan_tid_remove'
export const FF_LICENSE_DESCRIPTION = 'license_description'
export const FF_CIE_VIEW_ONLY = 'cie_view_only'
export const FF_IAM_PHASE_1 = 'iam_phase_1'
export const VMFLEX_ENABLED_SUPPORT_ACCOUNT_ID = 'vmflex_enabled_support_account_ids'
export const FF_ENHANCED_TSG_DELETE = 'enhanced_tsg_delete'
export const FF_COMMON_SERVICES_CUSTOM_ROLES = 'common_services_custom_roles'
export const FF_IAM_PHASE_2 = 'iam_phase_2'
export const FF_IP_ALLOW_LIST = 'ip_allow_list'
export const FF_ALLOW_PANW_IPS = 'allow_panw_ips'
export const FF_RC_TREE_V2 = 'rc_tree_v2'
export const FF_SDWAN_CSP_BYPASS = 'sdwan_csp_bypass'

const FF_IP_ALLOW_TSG_LIST = 'ip_allow_tsgs'

export const canUseIpAllow = (tsg: any) => {
  const ipAllowEnabled = getVarValue ? getVarValue(FF_IP_ALLOW_LIST, false) : false
  const ipAllowTSGs = getFrameworkVar(FF_IP_ALLOW_TSG_LIST)
  if (!ipAllowEnabled) {
    return false
  }
  if (!Array.isArray(ipAllowTSGs)) {
    return ipAllowEnabled
  }
  const intersection = _.intersection(tsg?.parent_ids, ipAllowTSGs)
  return !!(ipAllowTSGs.includes(tsg?.id) || intersection.length)
}
